module.exports = __webpack_public_path__ + "static/belgrade-8437da8bd738a030676bd5e9411027e6.jpg";